import Shipping from './Shipping.vue'
import MenuItem from "./../../../core/components/menu/MenuItem";
import i18n from '../../../shared/i18n'

let routes = [{
  path: 'shipping',
  name: 'shipping',
  component: Shipping,
  meta: {
    requiresAuth: true
  }
}];

export default {
  menuItem: new MenuItem('/shipping', i18n.t('Shipping'), 40, 'truck', [], 'view_invoice'),
  routes: routes
}
